module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "d_cal_dragged",
    staticClass: "d-cal__subjects__subject__dragged",
    style: (_vm.styleObj)
  }, [_vm._v("\n  " + _vm._s(_vm.subjectTitle) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c057be8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarDraggedSubject.vue
// module id = 1829
// module chunks = 1